export default __webpack_public_path__ + "media/Clean-Energy.4dc97f8f.svg";